<template>
  <div>
    <!-- MOBILE -->
    <section class="d-md-none">
      <!-- FILTER FOOTER -->
      <div class="mobile-footer" v-if="!filterSection" @click="showFilterSection">
        <!-- <span class="font-weight-bold text-rose-gold mr-1">3</span> -->
        Apply Filters
        <img src="@/assets/img/icons/up-arrow-icon.svg" class="ml-2" alt />
      </div>
      <!-- FILTER FOOTER AFTER FILTER BOX OPEN -->
      <div class="mobile-filter-footer" v-if="filterSection" @click="showFilterSection">
        <div class="mobile-filter-btn clear-btn">Clear All</div>
        <div class="mobile-filter-btn apply-btn">Apply Filters</div>
      </div>

      <!-- MOBILE FILTER POPUP -->
      <div class="mobile-Box" v-if="filterSection">
        <!-- MOBILE FILTER HEADER -->
        <div class="p-3 mobile-header">
          Choose Filter
          <span class="float-right" @click="closeFilterSection">
            <img src="@/assets/img/icons/close-white-icon.svg" alt />
          </span>
        </div>

        <div class="px-3 w-100">
          <div class="section-space-50"></div>
          <div class="section-space-25"></div>
          <div class="filter-box">
            <!-- LOOP FILTER SECTION -->
            <div class="mb-4">
              <p class="filter-title">Movie Formats</p>
              <ul class="list-inline filter-list">
                <li
                  class="list-inline-item mb-2"
                  :class="formatIndex == 1 ? 'active' : ''"
                  v-for="(format, formatIndex) in 5"
                  :key="formatIndex"
                >
                  <span class="box">2D</span>
                </li>
              </ul>
            </div>

            <div class="mb-4">
              <p class="filter-title">Languages</p>
              <ul class="list-inline filter-list">
                <li
                  class="list-inline-item mb-2"
                  :class="formatIndex == 0 ? 'active' : ''"
                  v-for="(format, formatIndex) in 8"
                  :key="formatIndex"
                >
                  <span class="box">Marathi</span>
                </li>
              </ul>
            </div>

            <div class="mb-4">
              <p class="filter-title">Genre</p>
              <ul class="list-inline filter-list">
                <li
                  class="list-inline-item mb-2"
                  :class="formatIndex == 4 ? 'active' : ''"
                  v-for="(format, formatIndex) in 15"
                  :key="formatIndex"
                >
                  <span class="box">Fantasy</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="section-space-50"></div>
          <div class="section-space-25"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      filterSection: false,
    };
  },
  methods: {
    showFilterSection: function () {
      this.filterSection = !this.filterSection;
    },
    closeFilterSection: function () {
      this.filterSection = false;
    },
  },
};
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/partials/applyFilters.vue